module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.26.0@babel-runtime/core-js/json/stringify.js
// module id = 48
// module chunks = 0